module.exports = __webpack_public_path__ + "img/024.7513d5ae.png";